<template>
  <div class="vp-h-full">
    <VpListEmpty
      :feature="{
        title: 'Google Merchant Center Integration',
        desc: 'To sync your products with Google Merchant Center, please complete your integration setup.',
      }"
    >
      <template #media>
        <VpIcon
          :name="$options.icons.GoogleMerchant"
          class="vp-h-14 vp-w-14 vp-mb-3 vp-text-blue-500"
        />
      </template>
      <template #action>
        <VyButton
          class="vp-mt-3 button--primary button--solid button--md button--rounded"
          label="Configure"
          :icon="$options.icons.Settings"
          @click.native="
            checkPermission('INTEGRATION_GMC', 'upsert', () => {
              $router.push({ name: 'google-merchant-center' });
            })
          "
        />
      </template>
    </VpListEmpty>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Settings, GoogleMerchant } from "icons/icons.js";

export default {
  icons: {
    Settings,
    GoogleMerchant,
  },
  computed: {
    ...mapGetters({
      checkPermission: "user/checkPermission",
    }),
  },
};
</script>
